import {V1_API_URL_PREFIX, ACCESS_TOKEN, BOUND_USER_ID, VERIFY_2FA_PATH, FALLBACK_2FA_CODE} from '../Constants';
import axios from 'axios';
import {NotificationManager} from "react-notifications";

export const request = (options) => {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    if (localStorage.getItem(BOUND_USER_ID)) {
        headers.append(BOUND_USER_ID, localStorage.getItem(BOUND_USER_ID));
    }
    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);

    return fetch(options.url, options)
        .then(async response => {
            const contentType = response.headers.get('content-type') || '';
            let payload = null;

            if (response.status !== 204 && response.status !== 205) {
                const rawBody = await response.text();
                if (rawBody && rawBody.trim().length > 0) {
                    if (contentType.indexOf('application/json') !== -1) {
                        try {
                            payload = JSON.parse(rawBody);
                        } catch (_err) {
                            payload = { message: rawBody };
                        }
                    } else {
                        payload = rawBody;
                    }
                }
            }

            if (!response.ok) {
                const json = payload && typeof payload === 'object' ? payload : { message: payload };
                console.log('error response from /user/me', json);
                if (
                    response.status === 401 &&
                    json && typeof json.message === 'string' && json.message.indexOf("JWT expired") !== -1
                ) {
                    const storedToken = JSON.parse(localStorage.getItem("token"));

                    try {
                        const responseJson = request({
                            url: V1_API_URL_PREFIX + "/auth/refresh",
                            method: 'POST',
                            body: JSON.stringify({
                                refresh_token: storedToken.refresh_token,
                            })
                        });

                        const { token, user } = responseJson;

                        localStorage.setItem("token", JSON.stringify(token));
                        localStorage.setItem("user", JSON.stringify(user));

                        return;
                    } catch (_error) {
                        return Promise.reject(_error);
                    }
                }
                return Promise.reject(Object.assign({}, json, { status: response.status }));
            }

            return payload;
        });
};

export function login(loginRequest) {
    return request({
        url: V1_API_URL_PREFIX + "/auth/sign-in",
        method: 'POST',
        body: JSON.stringify(loginRequest)
    });
}

// Verify 2FA code server-side. Sends { code, accessToken } to the verify endpoint.
export function verify2fa(code, pendingAccessToken) {
    // If the server endpoint is not configured or in dev, allow fallback code to pass locally.
    if (!VERIFY_2FA_PATH || VERIFY_2FA_PATH.length === 0) {
        return new Promise((resolve, reject) => {
            if (FALLBACK_2FA_CODE && FALLBACK_2FA_CODE === code) {
                resolve({ success: true });
            } else {
                reject({ message: 'Invalid 2FA code' });
            }
        });
    }

    const body = { code };
    if (pendingAccessToken) {
        body.pendingAccessToken = pendingAccessToken;
    }

    return request({
        url: V1_API_URL_PREFIX + VERIFY_2FA_PATH,
        method: 'POST',
        body: JSON.stringify(body)
    });
}

export function resend2fa(pendingAccessToken) {
    const body = { pendingAccessToken };
    return request({
        url: V1_API_URL_PREFIX + "/auth/resend-2fa",
        method: 'POST',
        body: JSON.stringify(body)
    });
}

export function acceptTermsAndConditions(termsAndConditionsRequest) {
    return request({
        url: V1_API_URL_PREFIX + "/user/acceptTermsAndConditions",
        method: 'POST',
        body: JSON.stringify(termsAndConditionsRequest)
    });
}

export function organisationDetails() {
    return request({
        url: V1_API_URL_PREFIX + "/organisation",
        method: 'GET'
    });
}

export function saveOrUpdateOrganisationDetails(organisationDetailsRequest) {
    return request({
        url: V1_API_URL_PREFIX + "/organisation/update",
        method: 'POST',
        body: JSON.stringify(organisationDetailsRequest)
    });
}

export function supportDetails() {
    return request({
        url: V1_API_URL_PREFIX + "/support",
        method: 'GET'
    });
}

export function saveOrUpdateSupportDetails(supportRequest) {
    return request({
        url: V1_API_URL_PREFIX + "/support/update",
        method: 'POST',
        body: JSON.stringify(supportRequest)
    });
}

export function saveOrUpdateSupportRevision(supportRequest) {
    return request({
        url: V1_API_URL_PREFIX + "/support/updateRevision",
        method: 'POST',
        body: JSON.stringify(supportRequest)
    });
}

export function saveOrUpdateOrganisationDetailsRevision(organisationDetailsRequest) {
    return request({
        url: V1_API_URL_PREFIX + "/organisation/updateRevision",
        method: 'POST',
        body: JSON.stringify(organisationDetailsRequest)
    });
}

export function traningRegister() {
    return request({
        url: V1_API_URL_PREFIX + "/training-register",
        method: 'GET'
    });
}

export function saveOrUpdateTrainingRegister(traningRegisterRecord) {
    return request({
        url: V1_API_URL_PREFIX + "/training-register/update",
        method: 'POST',
        body: JSON.stringify(traningRegisterRecord)
    });
}

export function deleteTrainingRegister(traningRegisterRecord) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/training-register/delete",
        method: 'DELETE',
        body: JSON.stringify(traningRegisterRecord)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function approvedSupplierList() {
    return request({
        url: V1_API_URL_PREFIX + "/approved-supplier-list",
        method: 'GET'
    });
}

export function saveOrUpdateApprovedSupplierList(approvedSupplierList) {
    return request({
        url: V1_API_URL_PREFIX + "/approved-supplier-list/update",
        method: 'POST',
        body: JSON.stringify(approvedSupplierList)
    });
}

export function deleteApprovedSupplierList(approvedSupplierList) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/approved-supplier-list/delete",
        method: 'DELETE',
        body: JSON.stringify(approvedSupplierList)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function signup(signupRequest) {
    return request({
        url: V1_API_URL_PREFIX + "/auth/sign-up",
        method: 'POST',
        body: JSON.stringify(signupRequest)
    });
}

export function checkUsernameAvailability(username) {
    return request({
        url: V1_API_URL_PREFIX + "/user/checkUsernameAvailability?username=" + username,
        method: 'GET'
    });
}

export function checkEmailAvailability(email) {
    return request({
        url: V1_API_URL_PREFIX + "/user/checkEmailAvailability?email=" + email,
        method: 'GET'
    });
}


export function getCurrentUser() {
    if(!localStorage.getItem(ACCESS_TOKEN)) {
        return Promise.reject("No access token set.");
    }

    return request({
        url: V1_API_URL_PREFIX + "/user/me",
        method: 'GET'
    });
}

export function bindUser(boundUserId) {
    return request({
        url: V1_API_URL_PREFIX + "/user/bind?boundUserId=" + boundUserId,
        method: 'POST'
    });
}

export function getUserProfile(username) {
    return request({
        url: V1_API_URL_PREFIX + "/users/" + username,
        method: 'GET'
    });
}


export function trackExport(pageName) {
    return request({
        url: V1_API_URL_PREFIX + "/user/trackExport?pageName=" + pageName,
        method: 'POST'
    });
}

export function getClients() {
    return request({
        url: V1_API_URL_PREFIX + "/clients",
        method: 'GET'
    });
}

export function getClientsForAdmin() {
    return request({
        url: V1_API_URL_PREFIX + "/clients/admin",
        method: 'GET'
    });
}

export function getActiveUsersForAdmin() {
    return request({
        url: V1_API_URL_PREFIX + "/users/active/admin",
        method: 'GET'
    });
}

export function calibrationSchedule() {
    return request({
        url: V1_API_URL_PREFIX + "/calibration-schedule",
        method: 'GET'
    });
}

export function calibrationScheduleRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/calibration-schedule/latestRevision",
        method: 'GET'
    });
}

export function approvedSupplierListRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/approved-supplier-list/latestRevision",
        method: 'GET'
    });
}

export function addApprovedSupplierListRevision(record) {
    return request({
        url: V1_API_URL_PREFIX + "/approved-supplier-list/add/revision",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function saveOrUpdateCalibrationSchedule(calibrationScheduleRecord) {
    return request({
        url: V1_API_URL_PREFIX + "/calibration-schedule/update",
        method: 'POST',
        body: JSON.stringify(calibrationScheduleRecord)
    });
}

export function addCalibrationScheduleRevision(calibrationScheduleRevisionRecord) {
    return request({
        url: V1_API_URL_PREFIX + "/calibration-schedule/add/revision",
        method: 'POST',
        body: JSON.stringify(calibrationScheduleRevisionRecord)
    });
}

export function deleteCalibrationSchedule(calibrationScheduleRecord) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/calibration-schedule/delete",
        method: 'DELETE',
        body: JSON.stringify(calibrationScheduleRecord)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

function checkFile(file) {
    //const fileInput = document.getElementById('fileInput');
    //const fileSize = fileInput.files[0].size;
    const fileSize = file.size;
    const maxSize = 10 * 1024 * 1024; // 10MB

    if (fileSize > maxSize) {
        // alert('File size must be less than 1MB');
        console.log('file check failed')
        NotificationManager.warning('Error', 'File size must be less than 10MB', 5000);
        return false;
    } else {
        console.log('file check passed')
        // Upload the file
        return true;
    }
}

export function uploadFile(endPoint, id, file, callback) {
    if (checkFile(file)) {
        let form = new FormData();
        form.append('id', id);
        form.append('fileName', file.name);
        form.append('selectedFile', new Blob([file]));
        let request = new XMLHttpRequest();
        request.open("POST", V1_API_URL_PREFIX + endPoint);
        if (localStorage.getItem(ACCESS_TOKEN)) {
            request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
        }
        request.send(form);
        request.onload = () => {
            callback(request.status, request.responseText);
        };
    }
}

export function importFile(endPoint, file, additionalFormData) {
    if (checkFile(file)) {
        let form = new FormData();
        // form.append('id', id);
        form.append('fileName', file.name);
        additionalFormData.forEach( function (eachObj){
            for (let key in eachObj) {
                if (eachObj.hasOwnProperty(key)){
                    form.append(key, eachObj[key]);
                }
            }
        });
        form.append('selectedFile', new Blob([file]));
        let request = new XMLHttpRequest();
        request.open("POST", V1_API_URL_PREFIX + endPoint);
        if (localStorage.getItem(ACCESS_TOKEN)) {
            request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
        }
        request.send(form);
        request.onload = () => {
            // callback(request.status, request.responseText);
            console.log('status', request.status);
            console.log('responseText', request.responseText);
            window.location.reload();
        };
    }
}

export function downloadFile(id) {
    console.log(id);

    var request = new XMLHttpRequest();
    request.open('GET', V1_API_URL_PREFIX + "/file/download?id=" + id, true);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    if (localStorage.getItem(ACCESS_TOKEN)) {
        request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    if (localStorage.getItem(BOUND_USER_ID)) {
        request.setRequestHeader(BOUND_USER_ID, localStorage.getItem(BOUND_USER_ID));
    }
    request.responseType = 'blob';

    request.onload = function() {
        // Only handle status code 200
        if(request.status === 200) {
            const disposition = request.getResponseHeader('Content-Disposition');
            const filename =  disposition.split('filename=')[1];
            const contentType = request.getResponseHeader('Content-Type');


            // The actual download
            let blob = new Blob([request.response], { type: contentType });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);
        }

        // some error handling should be done here...
    };

    request.send(null);
    /*
    const headers = new Headers();

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    fetch(V1_API_URL_PREFIX + "/file/download?id=" + id, defaults)
        .then(response => {
            const filename =  response.headers.get('Content-Disposition').split('filename=')[1];
            response.blob().then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
            });
        });
        */
}

/**
 * Fetches stored file bytes (same as download) and returns a blob URL for inline use (e.g. img src).
 * Call URL.revokeObjectURL when the URL is no longer needed.
 */
export function fetchFileAsObjectUrl(id) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', V1_API_URL_PREFIX + "/file/download?id=" + id, true);
        xhr.responseType = 'blob';
        if (localStorage.getItem(ACCESS_TOKEN)) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
        }
        if (localStorage.getItem(BOUND_USER_ID)) {
            xhr.setRequestHeader(BOUND_USER_ID, localStorage.getItem(BOUND_USER_ID));
        }
        xhr.onload = function () {
            if (xhr.status === 200) {
                resolve(URL.createObjectURL(xhr.response));
            } else {
                reject(new Error('File download failed: HTTP ' + xhr.status));
            }
        };
        xhr.onerror = function () {
            reject(new Error('File download network error'));
        };
        xhr.send(null);
    });
}

export function exportReport(endPoint) {
    let request = new XMLHttpRequest();
    request.open('GET', V1_API_URL_PREFIX + endPoint, true);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    if (localStorage.getItem(ACCESS_TOKEN)) {
        request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    if (localStorage.getItem(BOUND_USER_ID)) {
        request.setRequestHeader(BOUND_USER_ID, localStorage.getItem(BOUND_USER_ID));
    }
    request.responseType = 'blob';

    request.onload = function() {
        // Only handle status code 200
        if(request.status === 200) {
            const disposition = request.getResponseHeader('Content-Disposition');
            const filename =  disposition.split('filename=')[1];
            const contentType = request.getResponseHeader('Content-Type');

            // The actual download
            let blob = new Blob([request.response], { type: contentType });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;

            document.body.appendChild(link);

            link.click();
            document.body.removeChild(link);
        }
        // some error handling should be done here...
    };

    request.send(null);
}

export function search(term) {
    return axios.get(`${V1_API_URL_PREFIX}/search?term=${encodeURIComponent(term)}`, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem(ACCESS_TOKEN) //the token is a variable which holds the token
        }
    });
    /*

    if (localStorage.getItem(BOUND_USER_ID)) {
        headers.append(BOUND_USER_ID, localStorage.getItem(BOUND_USER_ID));
    }
     */
    /* return request({
        url: V1_API_URL_PREFIX + "/search?term=" + encodeURIComponent(term),
        method: 'GET'
    }); */
}

export function retrieveAllBackups() {
    return request({
        url: V1_API_URL_PREFIX + "/special/find-all-backups",
        method: 'GET'
    });
}

export function restore(fileName) {
    return request({
        url: V1_API_URL_PREFIX + "/special/restore?fileName=" + fileName + "&id=1",
        method: 'GET'
    });
}



export function positionDescriptions() {
    return request({
        url: V1_API_URL_PREFIX + "/position-descriptions",
        method: 'GET'
    });
}

export function saveOrUpdatePositionDescriptions(positionDescriptions) {
    return request({
        url: V1_API_URL_PREFIX + "/position-descriptions/update",
        method: 'POST',
        body: JSON.stringify(positionDescriptions)
    });
}

export function deletePositionDescriptions(positionDescriptions) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/position-descriptions/delete",
        method: 'DELETE',
        body: JSON.stringify(positionDescriptions)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function generateSignedTnC() {
    let request = new XMLHttpRequest();
    request.open('GET', V1_API_URL_PREFIX + "/admin/usersReport", true);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    if (localStorage.getItem(ACCESS_TOKEN)) {
        request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    if (localStorage.getItem(BOUND_USER_ID)) {
        request.setRequestHeader(BOUND_USER_ID, localStorage.getItem(BOUND_USER_ID));
    }
    request.responseType = 'blob';

    request.onload = function() {
        // Only handle status code 200
        if(request.status === 200) {
            const disposition = request.getResponseHeader('Content-Disposition');
            const filename =  disposition.split('filename=')[1];
            const contentType = request.getResponseHeader('Content-Type');

            // The actual download
            let blob = new Blob([request.response], { type: contentType });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;

            document.body.appendChild(link);

            link.click();
            document.body.removeChild(link);
        }
        // some error handling should be done here...
    };

    request.send(null);
}

export function submitChangePassword(oldPassword, password) {
    return request({
        url: V1_API_URL_PREFIX + "/user/changePassword",
        method: 'POST',
        body: JSON.stringify({ "oldPassword": oldPassword, "password" : password }),
    });
}


export function objectives() {
    return request({
        url: V1_API_URL_PREFIX + "/objectives",
        method: 'GET'
    });
}

export function saveOrUpdateObjectives(objectives) {
    return request({
        url: V1_API_URL_PREFIX + "/objectives/update",
        method: 'POST',
        body: JSON.stringify(objectives)
    });
}

export function deleteObjectives(objectives) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/objectives/delete",
        method: 'DELETE',
        body: JSON.stringify(objectives)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function flowchart() {
    return request({
        url: V1_API_URL_PREFIX + "/flowchart",
        method: 'GET'
    });
}
export function flowchartRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/flowchart/latestRevision",
        method: 'GET'
    });
}
export function saveOrUpdateFlowchart(supportRequest) {
    return request({
        url: V1_API_URL_PREFIX + "/flowchart/update",
        method: 'POST',
        body: JSON.stringify(supportRequest)
    });
}


export function deleteFlowchart(flowChart) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/flowchart/delete",
        method: 'DELETE',
        body: JSON.stringify(flowChart)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function addFlowchartRevision(review) {
    return request({
        url: V1_API_URL_PREFIX + "/flowchart/add/revision",
        method: 'POST',
        body: JSON.stringify(review)
    });
}

export function flowchartUploads() {
    return request({
        url: V1_API_URL_PREFIX + "/flowchart/uploads",
        method: 'GET'
    });
}